import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.34 5.152L12 3 9.66 5.152 6.439 4.72l-.563 3.049L3 9.218 4.43 12 3 14.781l2.875 1.451.563 3.05 3.223-.434L12 21l2.34-2.152 3.222.433.563-3.049L21 14.782 19.57 12 21 9.219l-2.875-1.451-.563-3.05-3.223.434z"
      fill="currentColor"
    />
    <path
      d="M8.019 11.814l1.338-1.273 1.697 1.613 3.393-3.227 1.339 1.273-4.732 4.5-3.035-2.886z"
      fill="#fff"
    />
  </svg>
);
